export default "__VITE_ASSET__CffxE$XI__"